// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "./static/js/" + chunkId + ".1736838249869.js?v=1736838249869";
};